module.exports = __webpack_public_path__ + "img/logo-opr.fb9d0076e8f205dd8bd5a42e297b9ddf.png";